// @flow

//
// React
//
import React from 'react';

//
// Formatter
//
import { fmtPercent } from '../../../../trix-web-data-commons';

//
// Components
//
import FloatPaneField from './FloatPaneField';

//
// Props
//
type Props = {
    //
    // State
    //
    fmt?: string,
    label: string,

    //
    // Data
    //
    value: number,

    //
    // Actions
    //
    onClick?: () => void;
}; // End of Props

//
// Component
//
const PercentFloatPaneField = (props: Props): any => {
    const value = fmtPercent(props.value);

    return(
        <FloatPaneField
            label={props.label}
            value={value}
            onClick={props.onClick}
        />
    );
};
export default PercentFloatPaneField;
